/* global $ window */

$.fn.extend({
    fadeInCss : function() {
        this.addClass('fade-1')

        // Add the fade class once a repaint has occured
        window.setTimeout(() => {
            this.addClass('fade-2')
        }, 33)

        return this
    },

    fadeOutCss : function() {
        return this.removeClass('fade-1 fade-2')
    },

    animateCss : function(animationName) {
        const animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend'

        this.addClass('animated ' + animationName).one(animationEnd, function() {
            $(this).removeClass('animated ' + animationName)
        })

        return this
    },

    fixHeight : function() {
        return this.height(this.outerHeight(true))
    },

    hasAttr : function(attr) {
        return this.attr(attr) !== undefined
    }
})



/** WEBPACK FOOTER **
 ** ./js/credentials/extend.js
 **/